// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/SuisseIntl-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}
.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.body {
  margin: 0 auto;
  font-family: "Raleway";
  font-feature-settings: "lnum";
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@font-face {
  font-family: "SuisseIntl";
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: local("SuisseIntl"), local("SuisseIntl"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
}
@font-face {
  font-family: "Raleway";
  font-style: normal;
  font-display: swap;
  font-weight: 400;
  src: local("SuisseIntl"), local("SuisseIntl"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("ttf");
  unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/constants/_colors.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;AADF;;AAIA;EACE;IACE,4CAAA;EADF;AACF;AAIA;EACE,yBCVa;EDWb,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;AAFF;;AAKA;EACE,cCtBS;ADoBX;;AAKA;EACE,cAAA;EACA,sBAAA;EACA,6BAAA;AAFF;;AAKA;EACE;IACE,uBAAA;EAFF;EAIA;IACE,yBAAA;EAFF;AACF;AAKA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qGAAA;EACA,gKAAA;AAHF;AAMA;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oGAAA;EACA,gKAAA;AAJF","sourcesContent":["@import '@/constants/colors';\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: $granite_grey;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: $heavenly;\n}\n\n.body {\n  margin: 0 auto;\n  font-family: 'Raleway';\n  font-feature-settings: \"lnum\";\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@font-face {\n  font-family: 'SuisseIntl';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: local('SuisseIntl'), local('SuisseIntl'), url(./assets/fonts/SuisseIntl-Regular.woff) format('woff');\n  unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;\n}\n\n@font-face {\n  font-family: 'Raleway';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src: local('SuisseIntl'), local('SuisseIntl'), url(./assets/fonts/Raleway-Regular.ttf) format('ttf');\n  unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;\n}\n","$black: #000000;\n$white: #ffffff;\n$grey: #6e6e6e;\n$slightly_grey: #e6e6e6;\n$light-gray: #def3db;\n$gray_smoke: #bdbdbd;\n$red: #ff0000;\n$heavenly: #61dafb;\n$granite_grey: #282c34;\n$periwinkle_crayola: #f1f9f7;\n$pale_blue: #d7d7d8;\n$dull_grey: #616161;\n$emerald: #5dc689;\n$light_green: #1dc255;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
